import React from "react";
import BehaviourBarGraph from "../BehaviourBarGraph.jsx";
import { formatMass } from "@signolteam/shared/units-of-measure";
import EmptyBarGraph from "../EmptyBarGraph";

let defaultMetadata = {
  discretionary_fuel_needed: 70,
  discretionary_fuel_loaded: 400,
  discretionary_fuel_loaded_penalty: 0,
  constant_odfl_buffer: 350,
};

export const behaviourMetadataFields = Object.keys(defaultMetadata);
export default function graph({
  unit = "kg",
  industry,
  metadata = defaultMetadata,
  missingDataMsg,
  bvrColour,
  isExample,
}) {
  let loaded = metadata["discretionary_fuel_loaded"];
  let neededFuel = metadata["discretionary_fuel_needed"];
  let threshold = metadata["constant_odfl_buffer"];

  let actual =
    loaded > threshold ? Number(loaded - neededFuel) : Number(loaded);
  if (!threshold) {
    return (
      <div className="relative text-center my-6 mx-auto text-2xl fill-current">
        {missingDataMsg}
      </div>
    );
  }

  neededFuel = Number(neededFuel);
  threshold = Number(threshold);

  const showNotNeeded = actual === 0 && neededFuel === 0;

  const diffText = "Difference between actual DF needed and DF loaded";
  const fuelText = "Discretionary fuel loaded";
  const showDiffText = loaded > threshold;

  const data = [
    {
      name: !!showDiffText ? diffText : fuelText,
      mobileName: "Label 1",
      beforeThreshold: actual > threshold ? threshold : actual,
      afterThreshold: actual > threshold ? actual - threshold : 0,
      underThresholdColour:
        actual > threshold ? bvrColour.codes["200"] : bvrColour.codes["500"],
      overThresholdColour: bvrColour.codes["900"],
    },
  ];

  const domainMin = 0;
  const margin = actual < threshold ? 0.1 * threshold : 0.1 * actual;
  const domainMax =
    actual < threshold
      ? Math.ceil(threshold + margin)
      : Math.ceil((actual + margin) / 100) * 100;
  const domain = [domainMin, domainMax];

  const mobileMargin = actual < threshold ? 0.05 * threshold : 0.05 * actual;
  const mobileDomainMax =
    actual < threshold
      ? Math.ceil(threshold + mobileMargin)
      : Math.ceil(actual + mobileMargin);
  const mobileDomain = [domainMin, mobileDomainMax];

  const thresholdLineColour = bvrColour.codes["900"];

  //data for empty graph
  const emptyData = [
    {
      name: fuelText,
      mobileName: "Label 1",
      beforeThreshold: 0,
      afterThreshold: 0,
      underThresholdColour: bvrColour.codes["500"],
      overThresholdColour: bvrColour.codes["900"],
    },
  ];
  const emptyDomain = [0, 400];

  return (
    <>
      {showNotNeeded ? (
        <EmptyBarGraph
          data={emptyData}
          threshold={350}
          thresholdLabel={`Signol threshold${
            !isExample ? ` (${formatMass(industry, threshold)})` : ""
          }`}
          mobileDomain={emptyDomain}
          domain={emptyDomain}
          refLineColour={thresholdLineColour}
          unitOfMeasure={unit}
          axisLabel={`Fuel (${unit})`}
          hideYLine={true}
          hideNum={true}
          hideTopLabel={true}
          message={"No DF was loaded. Great judgement."}
          messageColour={bvrColour.codes["100"]}
        />
      ) : (
        <BehaviourBarGraph
          data={data}
          threshold={threshold}
          thresholdLabel={`Signol threshold (${
            formatMass(industry, threshold, 0, { boundaryValues: [0, actual] })
              .formattedValue
          })`}
          mobileDomain={mobileDomain}
          domain={domain}
          refLineColour={thresholdLineColour}
          success={actual < threshold}
          unitOfMeasure={unit}
          axisLabel={`Fuel (${unit})`}
          hideYLine={true}
          hideNum={true}
          barLabelFormatter={(value) =>
            `${
              formatMass(industry, value, 0, { boundaryValues: [0, threshold] })
                .formattedValue
            }`
          }
          isExample={isExample}
        />
      )}
    </>
  );
}
